import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";

/**
 * Interfaz que modela cada registro del endpoint /statusneighbor
 */
export interface BgpStatus {
  ctxr: string;              // item.ctxr
  ctxr_description: string;  // item.ctxr_description
  neighbor: string;          // item.neighbor
  description: string | null; // item.description
  state: string;             // item.state
  up: string;                // item.up (uptime/downtime)
  local_as: number;
  peer_as: number;
  in: number;                // item.in
  out: number;               // item.out
}

/**
 * Columnas para la tabla:
 *  1) CTX-R / Description (combinado)
 *  2) Neighbor / Description (combinado)
 *  3) Status/ Time (combinado)
 *  4) Local AS/ Peer AS (combinado)
 *  5) Prefix RcV/Snt (combinado)
 */
export const statusColumns: GenericTableColumn<BgpStatus>[] = [
  {
    header: "CTX-R / Description",
    renderCell: (row) => (
      <div>
        <div>{row.ctxr}</div>
        <div className="text-sm text-gray-500">{row.ctxr_description}</div>
      </div>
    ),
  },
  {
    header: "Neighbor / Description",
    renderCell: (row) => (
      <div>
        <div>{row.neighbor}</div>
        <div className="text-sm text-gray-500">
          {row.description ?? ""}
        </div>
      </div>
    ),
  },
  {
    header: "Status/ Time",
    renderCell: (row) => (
      <div>
        <div>{row.state}</div>
        <div className="text-sm text-gray-500">
          {row.up}
        </div>
      </div>
    ),
  },
  {
    header: "Local AS/ Peer AS",
    // ¡Aquí hacemos lo mismo!
    renderCell: (row) => (
      <div>
        <div>{row.local_as}</div>
        <div className="text-sm text-gray-500">{row.peer_as}</div>
      </div>
    ),
  },
  {
    header: "Prefix RcV/Snt",
    renderCell: (row) => (
      <div>
        <div>{row.in}</div>
        <div className="text-sm text-gray-500">{row.out}</div>
      </div>
    ),
  },
];
